(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nv-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("size-guide-drawer")) {
    customElements.define(
      "size-guide-drawer",
      class extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector("[data-size-guide-open]");
          this.dialog = this.querySelector("dialog");
          this.closeButton = this.querySelector("[data-size-guide-close]");
          this.tabs = [...this.querySelectorAll("[data-size-guide-tab]")];
          this.panels = [...this.querySelectorAll("[data-size-guide-panel]")];
          this.unitButtons = [...this.querySelectorAll("[data-size-guide-unit]")];
          this.unitValues = [...this.querySelectorAll("[data-unit-value]")];
          this.trigger?.addEventListener("click", () => this.open());
          this.closeButton?.addEventListener("click", () => this.close());
          this.tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => this.selectTab(tab.dataset.sizeGuideTab));
            tab.addEventListener("keydown", (event) => this.handleTabKeydown(event, index));
          });
          this.unitButtons.forEach((button) => {
            button.addEventListener("click", () => this.selectUnit(button.dataset.sizeGuideUnit));
          });
          this.dialog?.addEventListener("click", (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog?.addEventListener("cancel", (event) => {
            event.preventDefault();
            this.close();
          });
        }

        selectTab(name) {
          const update = () => {
            this.tabs.forEach((tab) => {
              const active = tab.dataset.sizeGuideTab === name;
              tab.classList.toggle("is-active", active);
              tab.setAttribute("aria-selected", String(active));
              tab.tabIndex = active ? 0 : -1;
            });
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.sizeGuidePanel !== name;
            });
          };
          if (document.startViewTransition) document.startViewTransition(update);
          else update();
        }

        handleTabKeydown(event, index) {
          if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === "ArrowRight" ? 1 : -1;
          const next = (index + direction + this.tabs.length) % this.tabs.length;
          this.tabs[next].focus();
          this.selectTab(this.tabs[next].dataset.sizeGuideTab);
        }

        selectUnit(unit) {
          this.unitButtons.forEach((button) => {
            const active = button.dataset.sizeGuideUnit === unit;
            button.classList.toggle("is-active", active);
            button.setAttribute("aria-pressed", String(active));
          });
          this.unitValues.forEach((value) => {
            value.textContent = value.dataset[unit];
          });
        }

        open() {
          if (!this.dialog || this.dialog.open) return;
          this.dialog.showModal();
          document.body.classList.add("nv-size-guide-open");
          requestAnimationFrame(() => {
            this.dialog.classList.add("is-visible");
            this.closeButton?.focus();
          });
        }

        close() {
          if (!this.dialog?.open) return;
          this.dialog.classList.remove("is-visible");
          document.body.classList.remove("nv-size-guide-open");
          window.setTimeout(() => {
            this.dialog.close();
            this.trigger?.focus();
          }, 280);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
